import { useSelector } from 'react-redux';
import { type VoidFunctionComponent } from 'react';
import FilterCard from '../../generic/Filter/FilterCard';
import { useTeamsSelectOptions } from '../../shared/teams/hooks';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import type { AnyFilter } from '../../../../shared/organizationPackages';
import type { SelectOption } from '../../../types';

type Props = {
  setFilters: (filters: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersProjectTeams allows the user to filter packages based
 * on which teams are associated with the project.
 */
const PackageInventoryFiltersProjectTeams: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const teamIds = useSelector(PackageInventoryStore.selectors.getFiltersProjectTeamIds) as number[];
  const {
    isLoading,
    teamOptions,
    selectedTeamOptions,
    onTeamsSelected,
  } = useTeamsSelectOptions({
    selectedIds: teamIds,
    onTeamsChange: (nextTeamIds: number[]) => setFilters({ teamIds: nextTeamIds }),
  });
  return (
    <FilterCard.MultiSelect
      label="Team"
      placeholder={isLoading ? 'Loading...' : 'Select teams...'}
      options={teamOptions}
      values={selectedTeamOptions}
      onChange={selectOptions => onTeamsSelected(selectOptions as Array<SelectOption<number>>)}
    />
  );
};

export default PackageInventoryFiltersProjectTeams;
